import React from 'react';
import { ContentWrapper } from '../common';

interface Props {
    children: JSX.Element[] | JSX.Element | string;
}

const Message: React.FC<Props> = ({ children, ...rest }) => (
    <ContentWrapper>
        <div {...rest}>{children}</div>
    </ContentWrapper>
);

export default Message;
